import React from 'react';
import styles from './styles.module.css';
import { Icon } from 'common/icon';
import Link from 'next/link';
import { Routes } from 'constants/routes';
import { useVariablesByNameQuery } from 'hooks/api/variables';
import { useSlotReviewsByCasinoQuery } from 'hooks/api/slot_reviews';

export const NotVerifiedReviewsBlock = ({ casinoId }: { casinoId: string }) => {
  const { data: { results = [] } = {} } = useSlotReviewsByCasinoQuery(
    { casino_id: casinoId?.toString() ?? '', isReviewed: 'false' },
    { skip: !casinoId }
  );

  const { data: link } = useVariablesByNameQuery({
    name: 'link-rtpi-guide-add',
  });

  return (
    <Link
      href={Routes.guidePage(link?.value ?? '')}
      className={styles.container}
    >
      <div className={styles.notVerifiedReviewsBlock}>
        <div className={styles.content}>
          <div className={styles.info}>
            <div className={styles.count}>
              <div className={styles.circle}>
                <Icon.Search />
              </div>
              <div className={styles.text}>{results?.length}</div>
            </div>
            <div className={styles.text}>slot RTP reviews not verified</div>
          </div>
          <div className={styles.question}>
            <div className={styles.icon}>
              <Icon.Guide />
            </div>
            <div className={styles.text}>
              How users could add and get verified RTP review ?
            </div>
          </div>
        </div>
        <div className={styles.button}>
          <Icon.Arrow />
        </div>
      </div>
    </Link>
  );
};
